/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentUsername', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-username',
        replace: true,
        scope: {
          formObj: "=",
          formScope: "="
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: [function() {}]
      };

    }]);
}());